import { render, staticRenderFns } from "./yqg-image-modal.vue?vue&type=template&id=36940ce4&scoped=true&"
import script from "./yqg-image-modal.js?vue&type=script&lang=js&"
export * from "./yqg-image-modal.js?vue&type=script&lang=js&"
import style0 from "./yqg-image-modal.scss?vue&type=style&index=0&id=36940ce4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36940ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36940ce4')) {
      api.createRecord('36940ce4', component.options)
    } else {
      api.reload('36940ce4', component.options)
    }
    module.hot.accept("./yqg-image-modal.vue?vue&type=template&id=36940ce4&scoped=true&", function () {
      api.rerender('36940ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/component/yqg-image-modal/yqg-image-modal.vue"
export default component.exports